// extracted by mini-css-extract-plugin
module.exports = {"panel":"styles_panel__tuNI4","panel_item":"styles_panel_item__Rvv_w"};